export const useDefaultData = ({ Helpers }) => {

    const { getCurrentDate } = Helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idreception: '',
        idauthority: '',
        idrate: '',
        idlocation: '',
        vehicle_placa: '',
        vehicle_marca: '',
        vehicle_linea: '',
        vehicle_color: '',
        vehicle_modelo: '',
        vehicle_chasis: '',
        vehicle_motor: '',
        jsonRate: '',
        info_rate: '',
        info_numero_diligencia: '',
        info_numero_proceso: '',
        info_cliente: '',
        info_dpi: '',
        info_motivo_recepcion: '',
        info_tiene_llaves: '',
        info_observaciones: '',
        info_fecha_ingreso: getCurrentDate(),
        info_flag_cancelado: '',
        queryDate: '',
        queryDateInLetters: '',
    }
    
    const defaultFormOtherExpense = {
        idexpensereception: '',
        idreception: '',
        idexpense: '',
        costo: '',
        observation: ''
    }

    const defaultFormFiles = {
        idreception: '',
        files :[],
        acceptedFiles: [],
        fileRejections: []
    }

    const defaultReturnCertificateForm = {
        idreception: '',
        nameToReturnToAdd: '',
        addressToAdd: '',
        phoneToAdd: ''
    }

    const defaultExitPassForm = {
        idreception: '',
        titularTextToAdd: '',
        observationsToAdd: ''
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen,
        defaultFormOtherExpense,
        defaultFormFiles,
        defaultReturnCertificateForm,
        defaultExitPassForm
    })
}